/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetStockups200ResponseAllOfData } from './GetStockups200ResponseAllOfData';
import {
    GetStockups200ResponseAllOfDataFromJSON,
    GetStockups200ResponseAllOfDataFromJSONTyped,
    GetStockups200ResponseAllOfDataToJSON,
} from './GetStockups200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetStockups200Response
 */
export interface GetStockups200Response {
    /**
     * 
     * @type {GetStockups200ResponseAllOfData}
     * @memberof GetStockups200Response
     */
    data: GetStockups200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof GetStockups200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the GetStockups200Response interface.
 */
export function instanceOfGetStockups200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetStockups200ResponseFromJSON(json: any): GetStockups200Response {
    return GetStockups200ResponseFromJSONTyped(json, false);
}

export function GetStockups200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStockups200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetStockups200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function GetStockups200ResponseToJSON(value?: GetStockups200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetStockups200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

